module.exports = __webpack_public_path__ + "img/chr_ts_90_7.151eeac9.png";